import { render, staticRenderFns } from "./configPro.vue?vue&type=template&id=d94909f2&scoped=true&"
import script from "./configPro.vue?vue&type=script&lang=js&"
export * from "./configPro.vue?vue&type=script&lang=js&"
import style0 from "./configPro.vue?vue&type=style&index=0&id=d94909f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94909f2",
  null
  
)

export default component.exports